import { useMediaQuery } from "@mui/material";

export const useIsDownSm = () => useMediaQuery('(max-width: 600px)', {
  noSsr: true,
});